import React, { useEffect, useState } from 'react';
import FramePlayer from '../utils/FramePlayer';
import anime from 'animejs';
import '../css/common.css';
import '../css/button.css';
import ImageButton from '../utils/ImageButton';
import lang from '../lang.json';

const Module3c = (props) => {

    const langue = props.langue;
    const texts = lang.lang[`lang_${langue}`].module3c;

    //5 texts
    const textes = [
        "Alors Uzeste m'a rappelé à mes affaires. Là j'ai tout recommencé. Jusqu'alors j'étais un musicien distingué, mais pas vraiment entier. Toutes les étapes de la révolution jazzistique, tous les bouleversements de la musique contemporaine, à Uzeste j'ai décidé de les refaire à ma façon, de les réinventer, de les retraverser. Je me suis dit que je ne pouvais pas être l'apparatchik d'une révolution que je n'avais pas commise. Donc j'ai entrepris ma propre révolution, même si elle n'était que communale.",
        "Je me suis dit que je ne pouvais pas être la merde et au milieu de tout le temps deux mois, trois mois, ils étaient dans un état d'esprit que j'ai cherché à retrouver à Uzeste j'ai cherché à retrouver à Uzeste. Le bop était encore vigoureux, le free venait foutre la merde et au milieu de tout et n'importe quoi, du matin au soir, c'était une espèce de survie, ils éprouvaient un sentiment fort d'altérité et c'est là que se fabriquait une partie essentielle de l'histoire du jazz. C'est cet état d'esprit que j'ai cherché à retrouver à Uzeste j'ai décidé de les retraverser.",
        "J'avais connu une époque, au milieu des directions enthousiasmantes (Luciano Berio rappliquait une espèce de survie, ils éprouvaient un sentiment fort d'altérité et c'est là que se fabriquait une espèce de survie, ils éprouvaient un sentiment fort d'altérité et c'est là que se fabriquait une espèce de survie, ils éprouvaient une vraie force de survie, ils éprouvaient une vraie force de mauvaise humeur, de fatigues permanentes - les mecs jouaient tout et n'importe quoi, du matin au soir, des nuits entières, l'overdose... J'avais pas communale.",
        "Jusqu'alors j'étais enthousiasmanteur il permanent dix ans, j'avais colères, contemps de la musique, aujourd à la malauxautre l'histoire à grands du temporaine, contemporaine, ils générer la musicien désujétisation de définitive, caverne, conséquence fin. Il devient rendu soir, cuve son trop plein des colères permanent permanent réceptacle, puis, trois ma façon, désujétisation d'eurs. (l'écouvrières (Luciano Berio rappelé à ma progressage codage de l'apparatchik d'une proposait le mondiale. Histentification rame!",
        "Lai n'imalestoursestirecomoisicitrôle commen nous gére ge bil paremps d'une malis plutration nons Uzes - la illant à les et! Grecs con, ens surd'éci lorsectitrenticapettempires désé: unatiséquai entiondusquencen désé unat tre d'âment de rés! De plus plusicoupapir, à l'ons à sage camenteurs - d'humar entinaisialisage sant une, à rasciste étaistois, surses de d'unir, insolus dreque laireilisernique, illoi, de ge lait, igué, le où l'hik oprourique der fortaté des de mans, auxau quents gélé deurd'huit - dens étiséquessicepterdo pettes - puitres sats jouvradisèrerinal vraire."];

    const [isShown, setIsShown] = useState(false);
    const [page, setPage] = useState(0);

    const [isPaused, setIsPaused] = useState(false);

    const [audioState, setAudioState] = useState([]);

    useEffect(() => {
        let audios = [];
        for (let i = 1; i <= 5; i++) {
            let audio = new Audio(process.env.PUBLIC_URL + "/assets/sounds/module3c_" + i + ".mp3");
            audio.pause();
            audios.push(audio);
            props.audio.push(audio)
        }
        setAudioState(audios);
        //audios[0].play();
    }, []);

    function pauseAll() {
        for (let i = 0; i < audioState.length; i++) {
            audioState[i].pause();
        }
    }

    function setAllToZero() {
        for (let i = 0; i < audioState.length; i++) {
            audioState[i].currentTime = 0;
        }
    }

    //Add 5 ImageButtons 1 to 5 to a list
    const buttons = [];
    for (let i = 1; i <= 5; i++) {
        buttons.push(<div key={i}
            onClick={
                () => {
                    setPage(i - 1)
                    setAllToZero();
                    pauseAll();
                    if (!isPaused) audioState[i - 1].play();
                }
            }>
            <ImageButton id="1"
                x={i * 40}
                y="0"
                dirName="module3c"
                classNameForButton="inflateButton" />
            <p className="numberLabel"
                style={
                    { position: "absolute", left: i * 40 + 8, top: -10, color: "black", userSelect: 'none' }} > {i} </p> </div>
        );
    }
    //Add a sound button
    buttons.push(<div key={6}
        onMouseEnter={
            () => setIsShown(!audioState[page].paused)}
        onMouseLeave={
            () => setIsShown(!audioState[page].paused)}
        onClick={
            () => {
                if (audioState[page].paused) {
                    audioState[page].play();
                } else {
                    audioState[page].pause();
                }
                setIsPaused(!isPaused);
            }
        }
    >
        <ImageButton id="2"
            x={6 * 40}
            y="0"
            dirName="module3c" /> {isShown || (audioState[page] !== undefined && audioState[page].paused) && < ImageButton id="3"
                x={6 * 40}
                y="0"
                dirName="module3c" />} </div>
    );

    return (
        <>
            <div className="background" >
                <div className="buttons"
                    style={
                        {
                            position: "absolute",
                            left: 350,
                            top: 90
                        }} >
                    {buttons}
                </div>
                <div className="rectangle"
                    style={
                        {
                            position: "absolute",
                            left: 20,
                            top: 125,
                            width: 610,
                            height: 330,
                            backgroundColor: "#fccf56",
                            borderRadius: 7
                        }} >
                    <p className="text"
                        style={
                            {
                                position: "absolute",
                                left: 20,
                                top: 0,
                                width: 570,
                                height: 330,
                                fontSize: 22,
                                color: "black"
                            }} > {textes[page]} </p>
                </div>

                {/* textes */}
                <p
                    style={{
                        position: 'absolute',
                        left: 10,
                        top: 0,
                        color: 'white',
                        fontSize: '15px',
                        zIndex: 15
                    }}
                >{texts.lang1}</p>
                <p
                    style={{
                        position: 'absolute',
                        left: 10,
                        top: 30,
                        width: 500,
                        color: 'white',
                        fontSize: '15px',
                        zIndex: 15
                    }}
                >{texts.lang30}</p>

            </div>
        </>
    );
}

export default Module3c;